export default {
  mixed: {
    required: 'El campo es obligatorio',
    notOneOf: 'Este valor no es valido',
  },
  number: {
    min: 'Debe ser mayor que ${min}',
    max: 'Debe ser menor que ${max}',
  },
  string: {
    min: 'El mínimo de caracteres es ${min}',
    max: 'El máximo de caracteres es ${max}',
    matches: ({ regex }) => `Solo acepta caracteres con el siguiente formato ${regex}`,
    url: 'Debe ingresar una URL válida',
  },
}
